import { configureStore } from '@reduxjs/toolkit';
import loginSlice from './slices/loginSlice';
import communityListSlice from './community/slices/communityListSlice';

export default configureStore({
  reducer: {
    loginSlice: loginSlice,
    communityList: communityListSlice, // 커뮤니티 리스트 관련 reducer
  },
});
